import * as React from 'react'
import { TaskChangesMainConnected } from './TaskChangesMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskChangesMainExamples = () => {
  return (
    <div className="TaskChangesMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskChangesMainConnected />
      </Provider>
    </div>
  )
}
